import { VAMOO_THEME_COLORS, VAMOO_THEME_ID, type ThemeColors } from "@/shell/theme";

/** Os temas prontos do seletor. As cores aqui são as mesmas dos blocos
 *  `[data-theme="<id>"]` de `tokens.css` — esta lista desenha a
 *  miniatura e serve de ponto de partida do tema personalizado ("Começar
 *  de"); quem pinta o app de verdade é o CSS. Mexeu num, mexe no outro. */
export interface ThemePreset {
  id: string;
  name: string;
  description: string;
  colors: ThemeColors;
  /** Imagem atrás do menu na miniatura (só o VAMOO tem). */
  railImage?: string;
  /** Tema oculto: só aparece no seletor de quem destravou (`isVamooUnlocked`). */
  secret?: true;
}

/** A imagem do tema VAMOO (também na miniatura do tema personalizado com ele ligado). */
export const VAMOO_RAIL_IMAGE = "/brand/vamoo-universe.webp";

export const THEME_PRESETS: ThemePreset[] = [
  // FILEIRA 1: Criativos e Modernos (matizes isolados, sem tocar cores de polaridade)
  {
    id: "default",
    name: "Electric Growth",
    description: "Grafite fosco profundo com pop de verde-limão, azul elétrico e sky blue",
    colors: { rail: "#1a1a1e", accent: "#305cff", card1: "#b8fa4e", card2: "#305cff", card3: "#94a6ff" }
  },
  {
    id: "aubergine",
    name: "Electric Violet & Turbo",
    description: "Fundo Haiti azul-escuro profundo com destaque em Electric Violet e pop amarelo Turbo",
    colors: { rail: "#18102b", accent: "#834dfb", card1: "#f0e100", card2: "#834dfb", card3: "#f5f3ff" }
  },
  {
    id: "crimson",
    name: "Obsidian & Indigo Orange",
    description: "Fundo Preto puro com contraste vibrante em Laranja elétrico, Roxo Índigo e Off White",
    colors: { rail: "#0a0a0c", accent: "#ff4c00", card1: "#ff4c00", card2: "#4437d4", card3: "#e6e6e6" }
  },

  // FILEIRA 2: Monocromáticos (uma única família de matiz, sóbrios)
  {
    id: "bordeaux_mono",
    name: "Dark Indigo & Fire Red",
    description: "Base Dark Indigo profunda com contraste em vermelho fogo, lilac e amarelo suave",
    colors: { rail: "#23003f", accent: "#f94500", card1: "#f94500", card2: "#bcacce", card3: "#fffdb4" }
  },
  {
    id: "mocha_mono",
    name: "Vibrant Red & Pastel Pop",
    description: "Fundo Vermelho vibrante com acentos pop em Pink, Purple e Verde Limão pastel",
    colors: { rail: "#eb4213", accent: "#ff99dc", card1: "#ff99dc", card2: "#826dee", card3: "#d8f382" }
  },
  {
    id: "obsidian_mono",
    name: "Mirage & Blaze Orange",
    description: "Fundo Mirage azul-petróleo escuro com contraste vibrante Blaze Orange, Deep Sea Green e Wild Sand",
    colors: { rail: "#16232a", accent: "#ff5b04", card1: "#ff5b04", card2: "#075056", card3: "#e4eef0" }
  },

  // FILEIRA 3: Versões Light
  {
    id: "light",
    name: "Light Lime & Slate",
    description: "Fundo claro com toque de verde e destaque em Verde-Limão, Verde-Água e Slate",
    colors: { rail: "#e2e8e0", accent: "#84cc16", card1: "#bef264", card2: "#0d9488", card3: "#334155" }
  },
  {
    id: "lavender",
    name: "Light Cobalt & Orange",
    description: "Fundo claro Lukit Gray com destaque vibrante em Azul Cobalto, Laranja e Grafite",
    colors: { rail: "#dfe8f7", accent: "#0055ff", card1: "#0055ff", card2: "#ff6430", card3: "#16191b" }
  },
  {
    id: "rose_quartz",
    name: "Light Beige & Terracotta",
    description: "Fundo claro Bege suave com acentos marcantes em Terracota, Azul Marinho e Violeta",
    colors: { rail: "#e7dfdf", accent: "#e05a29", card1: "#e05a29", card2: "#132436", card3: "#9c90fc" }
  },

  // FILEIRA 4: o oculto (ver `VAMOO_THEME_ID` em `shell/theme.ts`)
  {
    id: VAMOO_THEME_ID,
    name: "VAMOO",
    description: "Fundo especial no menu e logo VAMOO. Só quem sabe o código vê",
    colors: VAMOO_THEME_COLORS,
    railImage: VAMOO_RAIL_IMAGE,
    secret: true
  }
];
